var _ellipse, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.24875,
    cy: 9.66567,
    rx: 5.50229,
    ry: 2.29262,
    stroke: "#7D8997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.751 12.875C13.751 14.1412 11.2876 15.1676 8.24875 15.1676C5.20992 15.1676 2.74646 14.1412 2.74646 12.875",
    stroke: "#7D8997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2534 9.66602C19.2534 10.9322 16.7899 11.9586 13.7511 11.9586",
    stroke: "#7D8997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.751 9.66602V16.5439C13.751 17.8101 11.2876 18.8365 8.24875 18.8365C5.20992 18.8365 2.74646 17.8101 2.74646 16.5439V9.66602",
    stroke: "#7D8997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2534 6.45605V13.3339C19.2534 14.6001 16.7899 15.6265 13.7511 15.6265",
    stroke: "#7D8997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7073 7.38193C8.43506 7.14823 8.26955 6.81389 8.24878 6.45571C8.24878 5.19018 10.7156 4.16309 13.7511 4.16309C16.7865 4.16309 19.2534 5.19018 19.2534 6.45571C19.2534 7.72123 16.7865 8.74833 13.7511 8.74833C13.5952 8.74833 13.4393 8.74833 13.2925 8.73916",
    stroke: "#7D8997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.3a1d17e633deaeaf7086991667a2e1f9.svg";
export { ForwardRef as ReactComponent };